import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postBonusesReferralIssue = (params) => {
    return axios.post(`${backendHost}/api/admin/referrals/bonuses/issue`, params);
};

export {
    postBonusesReferralIssue
}